import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import { Box, Link, Stack, Typography } from "@mui/material";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Flex } from "./Core/Flex";

type Props = {
  title: string;
  subtitle: string;
  actions?: React.ReactNode;
};

export const EmptyPage = ({ title, subtitle, actions }: Props) => {
  const { t } = useResource();

  return (
    <Stack direction={{ base: "column", sm: "row" }} width={"100%"} mt={Spacing.XXXL} spacing={Spacing.XXXL} justifyContent={"center"}>
      <Flex alignItems={"flex-start"} justifyContent={"center"} pt={Spacing.XL} mb={Spacing.XXXL}>
        <Box component={"img"} src={"/images/zfp_logo.svg"} alt="ZFP" width={"200px"} px={Spacing.L} />
      </Flex>
      <Stack flex={1} px={"35px"} sx={{ borderLeft: "4px solid", borderColor: "grey.400" }} maxWidth={"800px"} spacing={20}>
        <Stack spacing={Spacing.M}>
          <Typography variant="h1" mb={2} fontSize={"45px"}>
            {title}
          </Typography>
          <Typography variant="h6" mb={2} fontWeight={200}>
            {subtitle}
          </Typography>
        </Stack>
        <Stack spacing={Spacing.XL}>
          {actions}
          <Flex alignItems={"center"} gap={1}>
            <InfoOutlineIcon fontSize="small" sx={{ color: "grey.400" }} />
            <Box>
              <Typography component={"span"} fontSize={12} fontWeight={400} sx={{ color: "grey.400" }}>
                {t(Resources.Errors.ContactUs)}{" "}
              </Typography>
              <Link
                href={`mailto:${ANALYZER_EMAIL}`}
                fontSize={12}
                sx={{
                  color: "grey.400",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {ANALYZER_EMAIL}
              </Link>
            </Box>
          </Flex>
        </Stack>
      </Stack>
    </Stack>
  );
};
